// EventCard.jsx - Card Singolo Evento
import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import SchoolIcon from '@mui/icons-material/School';

const EventCard = ({ 
  event, 
  instructors, 
  currentUserId, 
  isIstruttoreAssegnato,
  onClick, 
  isMobile = false 
}) => {
  
  // Determina se l'utente corrente è coinvolto nell'evento
  const isUserEnrolled = event.iscritti?.some(u => u.anaUserId === currentUserId);
  const isUserInstructor = event.istruttore1Id === currentUserId || event.istruttore2Id === currentUserId;
  const isUserInvolved = isUserEnrolled || isUserInstructor;
  
  // Colori basati sul coinvolgimento dell'utente
  //const backgroundColor = isUserInvolved ? "#ABEBC6" : "#2c5282";
  //const textColor = isUserInvolved ? "#2c5282" : "#FFFFFF";
  let backgroundColor = "#2c5282"; // Colore di default (Blu scuro)
  let textColor = "#FFFFFF";
  if (isUserInstructor) {
    // Se sei il DOCENTE: Azzurro chiaro
    backgroundColor = "#e3f2fd"; 
    textColor = "#1565c0";
  } else if (isUserEnrolled) {
    // Se sei un ISCRITTO: Verde (come avevi prima)
    backgroundColor = "#ABEBC6";
    textColor = "#2c5282";
  }
  // Trova il nome dell'istruttore principale
  const instructor1Name = instructors.find(i => i.id === event.istruttore1Id)?.name || '-';
  const instructor2Name = event.istruttore2Id 
    ? instructors.find(i => i.id === event.istruttore2Id)?.name 
    : null;
  
  // Calcola i posti occupati (filtra solo gli iscritti attivi)
  const totalSlots = (event.utentiIstr1 || 0) + (event.utentiIstr2 || 0);
  const occupiedSlots = event.iscritti?.filter(i => i.deletedAt == null)?.length || 0;
  
  // Tooltip con informazioni dettagliate
  const tooltipContent = (
    <Box>
      {/* SE SEI DOCENTE: Mostra l'icona del cappello accademico */}
      {isUserInstructor && (
        <SchoolIcon sx={{ fontSize: '1rem', color: textColor, ml: 0.5 }} />
      )}
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {event.descrizione}
      </Typography>
      <Typography variant="body2">
        📅 {event.start.toLocaleDateString('it-IT')}
      </Typography>
      <Typography variant="body2">
        🕐 {event.start.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })} 
        ({event.durata}h)
      </Typography>
      <Typography variant="body2">
        👨‍🏫 {instructor1Name}
        {instructor2Name && ` + ${instructor2Name}`}
      </Typography>
      <Typography variant="body2">
        👥 {occupiedSlots}/{totalSlots} posti
      </Typography>
      
      {isUserInvolved && (
        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#4caf50', mt: 1 }}>
          {isUserInstructor ? '🎓 Sei istruttore' : '✅ Sei iscritto'}
        </Typography>
      )}
    </Box>
  );

  const eventCard = (
    <Box
      onClick={onClick}
      sx={{
        mt: isMobile ? 0 : 0.5,
        mb: isMobile ? 1 : 0,
        p: 1,
        borderRadius: 1,
        bgcolor: backgroundColor,
        color: textColor,
        cursor: 'pointer',
        display: 'inline-block',
        width: '100%',
        maxWidth: '100%',
        lineHeight: 1.2,
        transition: 'all 0.2s ease',
        '&:hover': {
          bgcolor: 'action.selected',
          color: '#2c5282',
          transform: 'translateY(-1px)',
          boxShadow: 1,
          '& *': {
            color: '#2c5282',
          },
        },
      }}
    >
      {/* Descrizione (sempre visibile, bold) */}
      <Typography 
        variant={isMobile ? "body1" : "subtitle2"} 
        sx={{ 
          fontWeight: 'bold', 
          color: textColor,
          mb: 0.25
        }} 
        noWrap
      >
        {event.descrizione}
      </Typography>
      
      {/* Istruttore principale */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.25 }}>
        <PersonIcon sx={{ fontSize: '0.875rem', color: textColor }} />
        <Typography 
          variant="body2" 
          sx={{ color: textColor }} 
          noWrap
        >
          {instructor1Name}
          {instructor2Name && ` +1`}
        </Typography>
      </Box>
      
      {/* Orario e durata */}
      <Typography variant="body2" sx={{ color: textColor, mb: 0.25 }}>
        {event.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} 
        ({event.durata}h)
      </Typography>
      
      {/* Posti occupati (solo se c'è spazio) */}
      
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <GroupIcon sx={{ fontSize: '0.75rem', color: textColor }} />
          <Typography variant="caption" sx={{ color: textColor }}>
            {occupiedSlots}/{totalSlots}
          </Typography>
        </Box>
      
      
      {/* Indicatore coinvolgimento utente per mobile */}
      {isMobile && isUserInvolved && (
        <Typography variant="caption" sx={{ 
          color: textColor, 
          fontWeight: 'bold',
          display: 'block',
          mt: 0.5
        }}>
          {isUserInstructor ? '🎓 Istruttore' : '✅ Iscritto'}
        </Typography>
      )}
    </Box>
  );

  // Su desktop mostra tooltip, su mobile no (troppo invasivo)
  if (isMobile) {
    return eventCard;
  }

  return (
    <Tooltip 
      //title={tooltipContent} 
      placement="top" 
      arrow
      enterDelay={500}
      leaveDelay={200}
    >
      {eventCard}
    </Tooltip>
  );
};

export default EventCard;